import { render } from "./App.vue?vue&type=template&id=19b0d1d5&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=19b0d1d5&scoped=true&lang=css"

import exportComponent from "D:\\projects\\bihua-portals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b0d1d5"]])

export default __exports__